// @flow

import { PostscribeCssBundle } from "./postscribe-css-bundle";
import { PostscribeJsBundle } from "./postscribe-js-bundle";
import { GlobalEventEmitterHandler } from "./global-event-emitter-handler";

export const createCssBundleList = (data: any, name: string) => {
	const cssPaths = [];
	const cssBundles: string | Array<string> = data[name].css;

	if (typeof cssBundles === "string") {
		cssPaths.push(cssBundles);
	}

	if (Array.isArray(cssBundles)) {
		cssPaths.push(...cssBundles);
	}

	const tasks = cssPaths.map(path => {
		return PostscribeCssBundle.exists(path)
			? [null]
			: [PostscribeCssBundle.push(path)];
	});

	return tasks;
};

export const createJsBundleList = (
	data: any,
	name: string,
	eventEmitterName: string,
	eventName: string,
	model: any
): Array<Promise<any>> => {
	const jsPaths = [];
	const jsBundles: string | Array<string> = data[name].js;

	if (typeof jsBundles === "string") {
		jsPaths.push(jsBundles);
	}

	if (Array.isArray(jsBundles)) {
		jsPaths.push(...jsBundles);
	}

	let pushed = false;
	const tasks = jsPaths.map(path => {
		return new Promise((resolve): Promise<any> => {
			if (!PostscribeJsBundle.exists(path)) {
				pushed = true;
				PostscribeJsBundle.push(path, resolve);
			}

			resolve();
		});
	});

	const jsJsBundlePromise = Promise.all(tasks).then(() => {
		if (!pushed) {
			GlobalEventEmitterHandler.emit(eventEmitterName, eventName, model);
		}
	});

	return [jsJsBundlePromise];
};